import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { fetchCart } from "slices/cartReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import ListItem from "./list-item";

const CartItems = ({ checkoutDates }: { checkoutDates: any }) => {
  const { cartReducer } = useAppSelector((state) => state);

  return (
    <Box
      sx={{
        border: "1px solid #E2E2E2",
        borderRadius: "10px",
        padding: { md: "25px", lg: "25px", xl: "25px", sm: "15px", xs: "15px" },

        my: { md: "35px", lg: "35px", xl: "35px", sm: "20px", xs: "20px" },
      }}
    >
      <Typography
        sx={{
          color: "#323232",
          fontWeight: 600,
          fontSize: "24px",
          lineHeight: "35px",
        }}
      >
        Cart
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          mt: "15px",
        }}
      >
        {cartReducer?.items?.map((item: any, index: number) => (
          <ListItem
            data={item}
            isLast={index + 1 === cartReducer?.items?.length}
            checkoutDates={checkoutDates}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CartItems;
